/**
 * GettingStartedCard
 * ==================
 * Place at: frontend/src/components/map/GettingStartedCard.jsx
 *
 * Extracted from Dashboard.jsx (September 2026). It shares no state with
 * the page — it takes props and renders — so living inside a 1,100-line
 * page component bought nothing and cost reuse.
 */

import React from 'react';
import { X, Plus, Sparkles, Compass } from 'lucide-react';
import { Button } from '../ui';


export const GettingStartedCard = ({ onDismiss, onCreateProject, projectCount, isLoading }) => {
  if (isLoading || projectCount > 0) return null;
  return (
    <div className="absolute top-32 left-1/2 -translate-x-1/2 z-20 w-full max-w-sm px-4 animate-in fade-in slide-in-from-top-4 duration-500 delay-300">
      <div className="bg-zinc-900/95 backdrop-blur-xl border border-zinc-800 rounded-2xl p-5 shadow-2xl">
        <div className="flex items-start justify-between mb-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-600 to-indigo-600 flex items-center justify-center shadow-lg shadow-purple-500/20">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <button onClick={onDismiss} className="text-zinc-500 hover:text-zinc-300 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <h3 className="text-sm font-bold text-white mb-1">Your cosmos is empty</h3>
        <p className="text-xs text-zinc-400 leading-relaxed mb-4">
          Create your first project to plant a star in the map. Or explore others' work and fork something that inspires you.
        </p>
        <div className="flex gap-2">
          <Button onClick={onCreateProject} icon={Plus} size="sm" className="flex-1">Create Project</Button>
          <Button variant="secondary" size="sm" icon={Compass} className="flex-1"
            onClick={() => window.location.href = '/explore'}>
            Explore
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GettingStartedCard;